<template>
  <div
    class="seg-part"
    :style="{'padding': `0 14%`}"
  >
    <div :class="{'shadow-modal': isShadow}" />
    <div class="seg-title-box">
      <div class="back-word">
        <slot name="back-word" />
      </div>
      <h2
        v-if="$slots['title-text']"
        class="title-text"
      >
        <slot name="title-text" />
      </h2>
      <div class="title-text-en">
        <slot name="title-text-en" />
      </div>
    </div>
    <div
      class="seg-main"
      :style="mainStyle"
    >
      <slot>some content here by default slot</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SegMain',
  props: {
    width: {
      type: String,
      default() {
        return '1300px';
      },
    },
    isShadow: {
      type: Boolean,
      default() {
        return false;
      },
    },
    mainStyle: {
      type: Object,
      default() {
        return {}
      }
    }
  },
};
</script>

<style scoped lang="less">
    @deep: ~">>>";
    .seg-part {
        width: 100%;
        margin: 20px auto;
        position: relative;
        overflow: hidden;
        box-sizing: border-box;
        background-size: cover!important;
        .seg-title-box {
            text-align: center;
            position: relative;
            z-index: 1;

            .back-word {
                font-size: 90px;
                color: #f6f6f6;
                font-weight: 600;
            }

            .title-text {
                font-size: 40px;
                position: absolute;
                bottom: -16px;
                width: 100%;
                font-weight: 400;
                color: #343434;
            }

            .title-text-en {
                position: absolute;
                bottom: 0;
                width: 100%;
                font-size: 16px;
                color: #505050;
            }
        }
        .seg-main{
            position: relative;
            padding: 30px 0;
        }
      .shadow-modal {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.25);
      }
    }
</style>
